/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crisp_Blue_Heron_LandInputs */

const en_crisp_blue_heron_land = /** @type {(inputs: Crisp_Blue_Heron_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const de_crisp_blue_heron_land = /** @type {(inputs: Crisp_Blue_Heron_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Crisp_Blue_Heron_LandInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const crisp_blue_heron_land = /** @type {((inputs?: Crisp_Blue_Heron_LandInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crisp_Blue_Heron_LandInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crisp_blue_heron_land(inputs)
	return de_crisp_blue_heron_land(inputs)
});